import { getObjectUtil } from 'packages/src'
import {
  STRIPE_KEY,
  STRIPE_PATH
} from 'modules/stripe/redux/constants/index.js'

export const isCreatingTokenStripeSelect = (state) => {
  return !!getObjectUtil(state, STRIPE_PATH[STRIPE_KEY.IS_CREATING_TOKEN])
}
